import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../../../components/ui/card';
import { cn } from '../../../lib/utils';

const StatCard = ({ icon, label, value, color, bg, className }) => {
    return (
        <motion.div
            whileHover={{ y: -4, scale: 1.02 }}
            className={cn("relative overflow-hidden group", className)}
        >
            <Card className="p-6 bg-card/40 backdrop-blur-xl border-border/40 rounded-3xl shadow-xl hover:border-primary/20 transition-all duration-300">
                <div
                    className="absolute top-0 right-0 w-32 h-32 blur-3xl opacity-20 group-hover:opacity-30 transition-opacity"
                    style={{ background: `radial-gradient(circle at top right, ${color}, transparent 70%)` }}
                />

                <div className="flex items-center justify-between mb-4">
                    <div
                        className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg"
                        style={{ background: bg, color: color, boxShadow: `0 8px 16px ${color}20` }}
                    >
                        {icon}
                    </div>
                    <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20">
                        <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                        <span className="text-[10px] font-black text-emerald-500 uppercase tracking-widest">Live</span>
                    </div>
                </div>

                <div>
                    <div className="text-4xl font-black text-foreground tracking-tighter leading-none mb-2">{value}</div>
                    <div className="text-[10px] font-black text-muted-foreground uppercase tracking-widest px-0.5">{label}</div>
                </div>
            </Card>
        </motion.div>
    );
};

export default StatCard;
